import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

/*
  ===== Copy Configuration =====
  (all editable text & structure lives here)
*/
const copy = {
    logoPath: "/assets/images/logo.jpeg",
    navItems: [
        { label: "Home", to: "/#" },
        { label: "Services", to: "/#services" },
        { label: "Testimonials", to: "/#testimonials" },
        { label: "About Us", to: "/#about" },
        { label: "Book Consultation", to: "/#book-consultation" },
    ],
    cta: { label: "Get in Touch", to: "/#contact" },
};

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();
    const toggleButtonRef = useRef(null);
    const mobileMenuRef = useRef(null);

    // Close mobile menu when route changes
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // Close menu when clicking outside
    useEffect(() => {
        function handleClick(e) {
            if (
                menuOpen &&
                mobileMenuRef.current &&
                !mobileMenuRef.current.contains(e.target) &&
                toggleButtonRef.current &&
                !toggleButtonRef.current.contains(e.target)
            ) {
                setMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, [menuOpen]);

    // Close menu on Escape
    useEffect(() => {
        function handleKey(e) {
            if (e.key === "Escape") setMenuOpen(false);
        }
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, []);

    // Add shadow when scrolled
    useEffect(() => {
        function handleScroll() {
            setIsScrolled(window.scrollY > 10);
        }
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const logoSrc = `${process.env.PUBLIC_URL}${copy.logoPath}`;

    return (
        <header
            className={`sticky top-0 z-50 w-full px-2 lg:px-12 transition-shadow duration-300 ${isScrolled ? "shadow-md" : ""
                }`}
            style={{ backgroundColor: "#2e2e2e" }}
        >
            <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" style={{ minHeight: 64 }}>
                {/* Logo */}
                <Link
                    smooth
                    to="/#"
                    className="flex items-center gap-3 no-underline hover:no-underline focus:no-underline active:no-underline"
                    aria-label={copy.brandName}

                >
                    <div className="leading-tight text-center">
                        <p className="text-[2rem] font-serif text-[#e96a1e] font-semibold">
                            Gantavyam
                        </p>
                        <p className="text-[1rem] text-[#ffffff] -mt-1">
                            Your wealth doctor
                        </p>
                    </div>

                </Link>


                {/* Desktop Nav */}
                <nav
                    className="hidden md:flex items-center gap-8"
                    aria-label="Primary navigation"
                >
                    {copy.navItems.map((item) => (
                        <Link
                            smooth
                            key={item.to}
                            to={item.to}
                            className="text-[#ffffff] hover:no-underline transition"
                        >
                            {item.label}
                        </Link>
                    ))}
                    <Link
                        smooth
                        to={copy.cta.to}
                        className="px-3 py-2 bg-[var(--color-primary)] text-[var(--bg-surface)] border border-[1px] border-[var(--color-primary)] hover:bg-[var(--bg-surface)] hover:text-[var(--color-primary)] rounded-md hover:no-underline transform transition shadow-sm"
                        role="button"
                    >
                        {copy.cta.label}
                    </Link>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    ref={toggleButtonRef}
                    className="md:hidden bg-transparent focus:outline-none focus:ring-0"
                    onClick={() => setMenuOpen((o) => !o)}
                    aria-controls="mobile-menu"
                    aria-expanded={menuOpen}
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                >
                    <i className={`fa-solid ${menuOpen ? "fa-xmark" : "fa-bars"} text-[#ffffff] text-2xl`} />
                </button>
            </div>

            {/* Mobile Dropdown */}
            {menuOpen && (
                <div
                    id="mobile-menu"
                    ref={mobileMenuRef}
                    className="md:hidden py-4 animate-slideDown"
                    style={{ backgroundColor: "#2e2e2e" }}
                >
                    {copy.navItems.map((item) => (
                        <Link
                            smooth
                            key={item.to}
                            to={item.to}
                            className="block text-[#ffffff] transition hover:font-semibold mx-4 py-3 border-b border-gray-200"
                            onClick={() => setMenuOpen(false)}
                        >
                            {item.label}
                        </Link>
                    ))}

                    <Link
                        smooth
                        to={copy.cta.to}
                        className="block mx-4 mt-2 bg-[var(--color-primary)] text-[var(--bg-surface)] border border-[1px] border-[var(--color-primary)] hover:bg-[var(--bg-surface)] hover:text-[var(--color-primary)] hover:no-underline py-3 px-3 rounded text-center"
                        onClick={() => setMenuOpen(false)}
                    >
                        {copy.cta.label}
                    </Link>
                </div>
            )}
        </header>
    );
}
